/*
 *
 * File: index.js
 *
 * Purpose: Create multistop app wide redux store.
 *
 * Author:  Thomas Burgard (Software development)
 * Created: 23.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { createStore, applyMiddleware, compose } from "redux";
import promiseMiddleware from "redux-promise";
import appReducers from "./reducers";

/**
 * Redux store for multistop app.
 *
 * @returns store redux store
 */
const ReduxStore = () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  // Create the redux store
  const store = createStore(
    appReducers,
    composeEnhancers(applyMiddleware(promiseMiddleware))
  );

  return store;
};

export default ReduxStore;
